// extracted by mini-css-extract-plugin
export default {"content":"Test_content__JzV2F"};